<template>
    <div class="vertical-wrapper">
        <md-progress-bar v-if="loading"  md-mode="indeterminate" style="flex: 0 0 5pt"> </md-progress-bar>
        <div v-if="loading"></div>

        <div v-if="charts.length" class="horizontal-wrapper" style="flex: 0 0 auto; margin: 0 5pt">
            <h2>{{ globalDashboardName }}</h2>
            <div>

            </div>
            <md-field class="hide">
                <label for="">Sortierung</label>
                <md-select v-model="chartsSortBy">
                    <md-option value="standart">Standart</md-option>
                    <md-option value="alphabetical">Alphabetisch </md-option>
                    <md-option value="increasing">Wert aufsteigend</md-option>
                    <md-option value="decreasing">Wert absteigend</md-option>
                </md-select>
            </md-field>
        </div>
        <div v-if="globalDashboardType == 'charts'" class="panel" style="overflow-y: scroll; flex: 1 0 0;">

            <charts v-for="(chart, i) in globalDashboardCharts" :key="chart.html_id" 
                :id="chart.html_id" :number="i" 
                :chart="chart" ref="chart"
                :maschine="{ id: chart.maschineId, name: chart.name.split(':')[0] }" 
                :class="{ 'edit': chart.edit }" 
                :edit="editMode"

                v-on:change-date-from="(e) => chart.from = e"
                v-on:change-date-till="(e) => chart.till = e"
                
                :self-request="true"
                :extra-controls="false"
            ></charts>

            
            <!--
                v-on:reorder-chart="graphReorder"
                v-on:item-clicked="graph_clicked(chart)" v-on:change-date="changeChartDates" 
                
            -->    

        </div>
        <div v-if="globalDashboardType == 'table'" class="vertical-wrapper" ref="table-wrapper">
            <md-table :value="globalDashboardTable" :md-sort.sync="tableSortBy" :md-sort-order.sync="tableSortOrder" md-card md-fixed-header :md-height="'auto'" :md-sort-fn="customSort">
                <md-table-toolbar>
                    <h1 class="md-title">{{ globalDashboardName }}</h1>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }} [{{ item.unit  }}]</md-table-cell>

                    <md-table-cell md-label="Wert" md-sort-by="value">{{ item.value.join(', ') }}</md-table-cell>
                    <md-table-cell md-label="MIN" md-sort-by="min" md-numeric>{{ item.min.join(', ') }}</md-table-cell>
                    <md-table-cell md-label="MAX" md-sort-by="max" md-numeric>{{ item.max.join(', ') }}</md-table-cell>
                    <md-table-cell md-label="AVG" md-sort-by="avg" md-numeric>{{ item.avg.join(', ') }}</md-table-cell>
                    
                    <md-table-cell md-label="Optionen">
                        <md-button v-on:click="$router.push({name : 'my_maschine', params: {id : item.maschineId, name: item.maschineName }})">Maschine</md-button>
                        <md-button v-on:click="openChartDialog(item)">Chart</md-button>

                    </md-table-cell>

                </md-table-row>
            </md-table>
        </div>

        <div v-if="globalDashboardType == 'iframe'" class="vertical-wrapper" >

            <iframe v-if="globalDashboardIframeUrl" style="flex: 1 0 0;" ref="global-dashboard-iframe" :src="iframeSrc" @load="iframeLoaded"></iframe>
            <div v-else class="vertical-wrapper"> 
                <div></div>
                <div class="horizontal-wrapper" style="flex: 2 0 0">
                    <div></div>
                    <md-button v-on:click="openIframeSettings">Einstellungen</md-button>
                    <div></div>
                </div>
            </div>

        </div>
        <!--For the settings dialogs-->
        <router-view></router-view>


        <md-speed-dial class="md-primary md-bottom-right" :class="{'hide': !display.editorMode }">
            <md-speed-dial-target class="md-primary">
            <md-icon :md-src="require('../../assets/icons/pen-solid.svg')" style="fill: white">add</md-icon>
            </md-speed-dial-target>

            <md-speed-dial-content >
            
            <md-button v-if="globalDashboardType == 'iframe'" class="md-icon-button" v-on:click="$router.push({ name: 'main-global-dashboard-iframe' })">
                <md-icon :md-src="require('../../images/add-items-icons/box-open-solid-full.svg')">frame</md-icon>
            </md-button>
            <md-button v-else class="md-icon-button" v-on:click="$router.push({ name: 'main-global-dashboard-charts' })">
                <md-icon :md-src="require('../../images/add-items-icons/chart-line-solid.svg')">Chart</md-icon>
            </md-button>


            <md-button class="md-icon-button" v-on:click="$router.push({ name: 'main-global-dashboard-settings' })">
                <md-icon :md-src="require('../../assets/icons/globe-solid.svg')">event</md-icon>
            </md-button>
            <md-button class="md-icon-button" v-on:click="$router.push({ name: 'main-global-dashboard-settings', params: { id: -1} })">
                <md-icon :md-src="require('../../images/circle-plus-solid.svg')">add</md-icon>

            </md-button>

            </md-speed-dial-content>
        </md-speed-dial>
    </div>
</template>
<script>
import charts from '@/components/charts.vue'
import { mapState } from "vuex";


export default {
    name: 'global-dashboard-view',
    props: { id: [String, Number]},
    components: {
        'charts':charts
    },
    computed:{
        token(){
            return this.$store.getters.token
        },
        editMode(){
            return this.$store.getters.getEditorMode
        },
        globalDashboardName(){
            const dashboards = this.$store.getters['globalView/getGlobalDashboards'] 
            const m = dashboards.find(e => e.id == this.id)
            return m ? m.name : ''
        },
        globalDashboardType(){
            const dashboards = this.$store.getters['globalView/getGlobalDashboards'] 
            const m = dashboards.find(e => e.id == this.id)
            return m ? m.type : ''
        },
        renderGlobalDashboardTable(){
            return this.$store.getters['globalView/getTable']?.length && this.globalDashboardType != 'iframe'
        },
        globalDashboardTable(){
            return this.$store.getters['globalView/getTable']
        },
        

        renderGlobalDashboardCharts(){
            return this.$store.getters['globalView/getCharts']?.length && this.globalDashboardType != 'iframe'

        },
        globalDashboardCharts(){
            return this.$store.getters['globalView/getCharts'] 
        },
        loading(){
            return this.$store.getters['globalView/getLoading']
        },

        globalDashboardIframeUrl(){
            return this.$store.getters['globalView/getIframeURL']

        },
        globalDashboardIframeAccessToken(){
            return this.$store.getters['globalView/getIframeAccessToken']

        },
        ...mapState(["display"]),

    },
   
    methods: {
        customSort(value) {
            const sortBy = this.tableSortBy
            return value.sort((a, b) => {
                if (typeof a[sortBy] == 'string' && this.tableSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy])
                } else if(typeof a[sortBy] == 'string'){
                    return b[sortBy].localeCompare(a[sortBy])
                } else if(Array.isArray(a[sortBy]) && this.tableSortOrder === 'asc'){
                    return Math.max(...a[sortBy]) - Math.max(...b[sortBy])
                } else if (Array.isArray(a[sortBy]) && this.tableSortOrder === 'desc') {
                    return  Math.min(...b[sortBy]) - Math.min(...a[sortBy]) 
                }


            })
        },
        openChartDialog(item){
            this.$router.push({ name : 'main-global-dashboard-chart-details', params: { id: this.id, 'chartId': item.id, maschineId: item.maschineId, type: item.type, html_id: item.html_id }})
        },

        sendMessage() {
            
           
            this.$nextTick(() => {
                const frame = this.$refs['global-dashboard-iframe'];

                if (!frame || !frame.contentWindow) {
                    console.warn("Iframe not ready");
                    return;
                }

                const message = { action: "access", payload: this.globalDashboardIframeAccessToken };
                frame.contentWindow.postMessage(message, "*");
                console.log('post message');
                
            })
            // Replace "*" with origin if you know it, e.g. "https://example.com"
        },
        iframeLoaded(){
            console.log('iframe loaded');
            this.sendMessage()
            
        },
        openIframeSettings(){
            this.$router.push({ name: 'main-global-dashboard-iframe' , params: {id: this.id}})
        }

    },
    beforeRouteEnter(to, from, next){
        next(async vm => {
            //vm.$socket.emit('get-global-dashboard-charts', { token: vm.token , IDh_global_db: vm.id})
            
            vm.charts = []
            vm.table = []

            vm.$store.commit('display/set-show-maschines', false);

            await vm.$store.dispatch('globalView/get-global-dashboards')
            await vm.$store.dispatch('globalView/fetch-global-dashboard-details', vm.$props.id)


            // set all menu opener values to false after entering a new maschine
            vm.$store.commit('display/set-show-maschines', false)
            vm.$store.commit('display/set-show-kategories', false)
            vm.$store.commit('display/set-burger-active', false)

            // 

            vm.iframeSrc = vm.globalDashboardIframeUrl + `?ts=${Date.now()}`


        })
    },
    beforeRouteUpdate: async function(to, from, next) {
        
        
        //this.$socket.emit('get-global-dashboard-charts', { token: this.token, IDh_global_db: to.params.id })
        this.charts = []
        this.table = []


       await this.$store.dispatch('globalView/fetch-global-dashboard-details', to.params.id)

        // set all menu opener values to false after entering a new maschine
        this.$store.commit('display/set-show-maschines', false)
        this.$store.commit('display/set-show-kategories', false)
        this.$store.commit('display/set-burger-active', false)


        
        this.iframeSrc = this.globalDashboardIframeUrl + `?ts=${Date.now()}`

        //next()
        
        next(vm => {
            this.iframeSrc = vm.globalDashboardIframeUrl + `?ts=${Date.now()}`

        })    
    },
    data(){
        return{

            charts: [],
            table: [],
            chartsSortBy: 'standart',


            tableSortBy: 'name',
            tableSortOrder: 'asc',

            iframeSrc: ''
        }
    }
}
</script>
<style>
.md-speed-dial .md-primary{
    background-color: var(--color3);
}
.md-speed-dial .md-primary svg{
    color: white;
}
</style>